<template>
  <div id="header">
    <div id="title">
      <div id="left">
        <img v-on:click="jumppage('./')"
             src="../images/logo.jpg"
             alt=""
             width="230"
             height="70"
             style="padding: 15px;"
             class="logo le" />
        <div id="sub_bottom">
          <!-- 导航条练习 -->
          <ul class="nav">
            <li>
              <a href="./#/about">{{ $t("header.about") }}</a>
            </li>
            <!-- <li><router-link to="/product">关于海1</router-link></li> -->
            <li>
              <a href="./#/news">{{ $t("header.news") }}</a>
            </li>
            <li>
              <a href="./#/video">{{ $t("header.video") }}</a>
            </li>
            <li>
              <a v-on:click="jumppage('./#/product')">{{ $t("header.product") }}</a>
            </li>
            <li>
              <a href="./">{{ $t("header.home") }}</a>
            </li>
          </ul>
        </div>
      </div>
      <div id="right">
        <a v-if="$i18n.locale == 'en'"
           class="langcn fr"
           @click="changeLanguage()"></a>
        <a v-else
           class="langen fr"
           @click="changeLanguage()"></a>
        <span class="search fr"><img src="../images/4.png" /><input :placeholder="$t('header.search')"
                 id="keyWord"
                 ref="keyword"
                 value=""
                 @keyup.enter="searchHandle" /></span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  data () {
    return {
      msg: "头部",
    };
  },
  methods: {
    changeLanguage () {
      this.$i18n.locale == "zh"
        ? (this.$i18n.locale = "en")
        : (this.$i18n.locale = "zh"); //设置中英文模式
      localStorage.setItem("languageSet", this.$i18n.locale); //将用户设置存储到localStorage以便用户下次打开时使用此设置
      //window.location.href="/"
    },
    jumppage (url) {
      var temp = window.location.href
      window.location.href = url
      if (temp.indexOf('/product/') > -1) {
        location.reload();
      }
      //this.$router.push({path:'/product'})
    },
    remind () {
      this.$toast("3");
    },
    searchHandle () {
      var temp = window.location.href
      window.location.href = "/#/product/0/" + this.$refs.keyword.value;
      if (temp.indexOf('/product/') > -1) {
        location.reload();
        this.$refs.keyword.value = "";
      }
    }
  },
};
</script>
<style scoped>
#header {
  position: fixed;
  top: 0px;
  left: 0px;
  bottom: 0px;
  width: 100%;
  height: 96px;
  background-color: #fff;
  z-index: 999;
  text-align: center;
}
#title {
  width: 1400px;
  height: 96px;
  display: inline-block;
}
#left {
  display: flex;
  text-align: left;
  float: left;
}
#left img {
  padding-top: 5px;
}
#sub_bottom {
  padding-top: 6px;
  padding-left: 10px;
}
#right {
  text-align: right;
  float: right;
  padding-top: 10px;
}
#sub_top {
  padding-top: 10px;
  height: 24px;
}

.nav {
  width: 100%;
}
.nav li {
  float: right;
  font-size: 17px;
  /* width: 68px; */
  text-align: center;
  margin-left: 40px;
  height: 90px;
  line-height: 90px;
}
.nav li a {
  color: #333;
}
.nav li:hover a {
  color: #00a0e9;
}
.nav li:hover {
  background: url(../images/nav_bg.jpg) no-repeat bottom center;
}
.nav li.on a {
  color: #00a0e9;
}
.nav li.on {
  background: url(../images/nav_bg.jpg) no-repeat bottom center;
}
/*语言选择2*/
.search {
  width: 202px;
  height: 30px;
  margin: 25px 0px;
  position: relative;
  background-color: #f5f5f5;
  border-radius: 30px;
}
.search img {
  width: 19px;
  height: 19px;
  position: absolute;
  left: 10px;
  top: 5px;
}
.search input {
  width: 150px;
  height: 30px;
  line-height: 30px;
  border: none;
  position: absolute;
  left: 35px;
  background-color: #f5f5f5;
  font-size: 12px;
  color: #a4a4a4;
}
/*语言选择1*/
.lang {
  width: 120px;
  height: auto;
  position: relative;
}
.language {
  width: 120px;
  height: 30px;
  margin: 20px 0;
  position: relative;
  background-color: #f5f5f5;
  border-radius: 30px;
  font-size: 12px;
  color: #a4a4a4;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
}
.language img {
  width: 12px;
  height: 7px;
  position: absolute;
  right: 10px;
  top: 12px;
}

.lang .chose {
  display: block;
  position: absolute;
  width: 120px;
  height: 105px;
  background-color: #fff;
  left: 0;
  bottom: -85px;
  z-index: 999;
  text-align: center;
  font-size: 12px;
  border-radius: 0 0 15px 15px;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.1);
}
.lang .chose a {
  display: block;
  width: 120px;
  height: 35px;
  line-height: 35px;
}
.lang .chose a img {
  display: inline-block;
  width: 23px;
  height: 16px;
  position: relative;
  left: 20px;
  top: 8px;
}
.language1 {
  background-color: #fff;
  box-shadow: 0px -1px 3px 0px rgba(0, 0, 0, 0.1);
  border-radius: 15px 15px 0 0;
}
/*语言选择2*/
.langcn {
  width: 30px;
  height: 30px;
  background-image: url(../images/cn.png);
  margin: 25px 40px 25px 20px;
}
.langen {
  width: 30px;
  height: 30px;
  background-image: url(../images/en.png);
  margin: 25px 40px 25px 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue